import type { ReactNode, Ref } from "react";

import { cn } from "../lib/cn";

type TagVariant = "primary" | "secondary" | "tertiary" | "error";

export type TagProps = {
    className?: string;
    children: ReactNode;
    variant?: TagVariant;
    ref?: Ref<HTMLSpanElement>;
};

export function Tag({ className, children, variant = "primary", ref }: TagProps) {
    return (
        <span
            ref={ref}
            className={cn(tagBaseClass, tagVariantClass[variant], className)}
        >
            {children}
        </span>
    );
}

const tagBaseClass = cn(
    "inline-flex w-fit items-center justify-center whitespace-nowrap px-8 py-[6px] text-center font-tag-text font-weight-tag uppercase tracking-tag",
    "text-mobile-tag-tag leading-mobile-tag-tag sm-md:text-desktop-tag-tag sm-md:leading-desktop-tag-tag",
    "gap-8",
);

const tagVariantClass: Record<TagVariant, string> = {
    primary:
        "bg-component-tag-background-primary bg-(image:--components-tag-primary-base-fill-gradient) text-component-tag-text-primary",
    secondary:
        "bg-component-tag-background-secondary bg-(image:--components-tag-secondary-base-fill-gradient) text-component-tag-text-secondary",
    tertiary:
        "rounded-full bg-component-tag-background-tertiary bg-(image:--components-tag-tertiary-base-fill-gradient) px-12 py-[6px] text-component-tag-text-tertiary",
    error: "bg-component-tag-background-error bg-(image:--components-tag-error-base-fill-gradient) text-component-tag-text-error",
};
